import { useQuery } from "react-query";
import { useFetchAllData } from "src/shared/lib/hooks/context";
import { apiRequests } from "src/shared/api/api";

export const useFetchGetPriceTypes = (options) => {
  const { token, name, } = options;
  const query = useQuery(
    ["priceTypes", token, name],
    async () => {
      const response = await apiRequests.prices.getTypes({ token, name });
      return response.data.result;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  return query;
};

export const useFetchAllPricesType = ({ token }) =>
  useFetchAllData({ token, key: "priceTypes", path: "price_types/" });